'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hover", "isFocus", "select"];
import React, { forwardRef } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TableRowElement } from "./TableRow.mjs";
/**
 * A TableRow is a horizontal stack of related cells.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablerow--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table#row) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableRow) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=20339-15708&t=s9ZDoQC7G8x5OYjx-1)
 */
export var TableRow = /*#__PURE__*/forwardRef(function TableRow(_ref, ref) {
  var hover = _ref.hover,
    isFocus = _ref.isFocus,
    select = _ref.select,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TableRowElement, Object.assign({
    ref: ref,
    $hover: hover,
    $isFocus: isFocus,
    $select: select
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.TableRow
  }));
});